import React, { useState } from "react";
import { BsPlus } from "react-icons/bs";
import CreateOrUpdateDestinationModal from "../create-or-update-destination/createOrUpdateDestinationModal";
import { useGlobalContext } from "context/globalContext";
import { consoleLog } from "helpers";
// import FormPopup from "FormModal/FormModal";

function CreateDestinationBtn(props) {
  const { transparent } = props;
  const [open, setOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { isOpenDestinationEditForm, setIsOpenDestinationEditForm } =
    useGlobalContext();

  const handleFormOpen = () => {
    setIsFormOpen(true);
  };
  const handleFormClose = () => {
    setIsFormOpen(false);
  };
  const handleFormSubmit = (formData) => {
    consoleLog(["Form submitted:", formData]);
  };

  return (
    <div className="relative">
      <button
        onClick={() => {
          setOpen(!open);
          handleFormOpen();
        }}
        className={`flex items-center text-xl hover:cursor-pointer ${
          transparent
            ? "bg-none text-white hover:bg-none active:bg-none"
            : "bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10 dark:!bg-gray-10 dark:text-white"
        } linear justify-center rounded-lg font-bold transition duration-200`}
      >
        <BsPlus className="fill-amber-900" />
      </button>
      <CreateOrUpdateDestinationModal
        isOpen={isFormOpen}
        onClose={handleFormClose}
        onSubmit={handleFormSubmit}
        isEditMode={false}
        // getSystemPromptData={getSystemPromptData}
      />
      <CreateOrUpdateDestinationModal
        isOpen={isOpenDestinationEditForm}
        onClose={() => setIsOpenDestinationEditForm(false)}
        onSubmit={handleFormSubmit}
        isEditMode={true}
      />
    </div>
  );
}

export default CreateDestinationBtn;
